import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import "../style/odds.css";
import axios from "axios";
import Spinner from "./Spinner";
import { AuthContext } from "../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReplayIcon from "@mui/icons-material/Replay";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import api_url from "../constants";

const months = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

function Revert() {
  const [authContext] = useContext(AuthContext);
  const config = {
    headers: { Authorization: `Bearer ${authContext.token}` },
  };
  const [isRefreshing, setRefreshing] = useState(false);
  const [password, setPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
    const [unsettledSettledBets, setUnsettledSettledBets] = useState([]); // Note: These are actually Settled Bets in this file

  
  // Data States
  const [matchOdds, setMatchOdds] = useState([]); // Stores Settled Session Bets
  const [loading, setLoading] = useState(true);
  const [matchList, setMatchList] = useState([]); // Stores All Matches (for headers)
  const [unresolvedMatches, setUnresolvedMatches] = useState([]); // Stores Settled Match Bets
  
  // Loading States
  const [resultLoading, setResultLoading] = useState("");
  const [matchLoading, setMatchLoading] = useState("");

  // --- Filter States ---
  const [filterMatchId, setFilterMatchId] = useState("");
  const [filterType, setFilterType] = useState("All"); // All, Match Bets, Session Bets

  // --- Toggle States (Main Sections) ---
  const [showMatchSection, setShowMatchSection] = useState(true);
  const [showSessionSection, setShowSessionSection] = useState(true);

  // --- Toggle State (Individual Session Matches) ---
  const [visibleSessions, setVisibleSessions] = useState({});

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleSession = (matchId) => {
    setVisibleSessions((prev) => ({
      ...prev,
      [matchId]: !prev[matchId],
    }));
  };

  const revertMatch = async (matchId) => {
    console.log("Reverting match:", matchId);
    setMatchLoading(matchId);
    try {
        const response = await axios.post(
        `${api_url}/bet/deleteMatchResult`,
        { matchId },
        config
        );
        toast.success(response.data.msg);
        getSettledMatch(); // Refresh data
    } catch (error) {
        console.error(error);
        toast.error("Failed to revert match");
    }
    setMatchLoading("");
  };

  const revertBet = async (fancyName, matchId) => {
    setResultLoading(fancyName);
    const data = { fancyName, matchId: matchId };
    try {
      const response = await axios.post(
        `${api_url}/bet/deleteFancyResult`,
        data,
        config
      );
      toast.success(response.data.msg);
      getSessionOdds(); // Refresh data
      setResultLoading("");
    } catch (error) {
      console.error(error);
      toast.error("Failed to revert bet");
      setResultLoading("");
    }
  };

  const getSessionOdds = async () => {
    try {
      const response = await axios.get(
        `${api_url}/bet/getLastHourSettledBets`,
        config
      );
      setMatchOdds(response.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  const getSettledMatch = async () => {
    try {
      const response = await axios.get(
        `${api_url}/bet/getLastHourSettledMatchBets`,
        config
      );
      setUnresolvedMatches(response.data);
      console.log("Settled Matches: ", response.data);
       setUnsettledSettledBets((prev) => [...prev, ...response.data]);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  async function getMatchData() {
    try {
      const response = await axios.get(`${api_url}/sports/getMatchList`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authContext.token}`,
        },
      });
      setMatchList(response.data);
      let unsettledMatches = response.data.filter((match) => match.settled === 0);
      setUnsettledSettledBets((prev) => [...prev, ...unsettledMatches]);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getMatchData();
    getSessionOdds();
    getSettledMatch();
  }, []);

  // --- Helper to Check Live Status ---
  const checkIsLive = (matchTimeStr) => {
    if(!matchTimeStr) return false;
    const matchTime = new Date(matchTimeStr);
    const currentTime = new Date();
    // 1. Must be the same day
    const isSameDay = matchTime.toDateString() === currentTime.toDateString();
    // 2. Current time must be past the match start time
    const hasStarted = currentTime >= matchTime;
    return isSameDay && hasStarted;
  };

  function timestampToString(timestamp) {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    const formattedDate = date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
    return formattedDate;
  }

  // --- Filter Logic ---
  const shouldShowMatchBets = filterType === "All" || filterType === "Match Bets";
  const shouldShowSessionBets = filterType === "All" || filterType === "Session Bets";

  // Filter the "Settled Matches" list
  const filteredSettledMatches = unresolvedMatches.filter((match) => {
    return filterMatchId === "" || match.event_id === filterMatchId;
  });

  // Filter the generic Match List used for Session Bet headers
  // Only show matches that actually HAVE settled bets in matchOdds
  const matchesWithSettledBets = matchList.filter(match => {
      const hasBets = matchOdds.some(odd => odd.match_id === match.event_id);
      const matchesFilter = filterMatchId === "" || match.event_id === filterMatchId;
      return hasBets && matchesFilter;
  });

  // --- SORTING LOGIC: Live matches to the top ---
  const sortedMatchList = [...matchesWithSettledBets].sort((a, b) => {
    const isLiveA = checkIsLive(a.time);
    const isLiveB = checkIsLive(b.time);

    // If A is live and B is not, A comes first (-1)
    if (isLiveA && !isLiveB) return -1;
    // If B is live and A is not, B comes first (1)
    if (!isLiveA && isLiveB) return 1;
    
    // If both are same status, sort by time (earliest first)
    return new Date(a.time) - new Date(b.time);
  });


  if (loading) {
    return (
      <div className="body-content no-padding">
        <Spinner color="#555" />
      </div>
    );
  }

  return (
    <>
      <style>
        {`
        .filter-container {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          align-items: center;
          margin: 15px 10px;
        }
        .filter-select {
          background: #fff;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 10px 14px;
          font-size: 15px;
          color: #333;
          outline: none;
          cursor: pointer;
          min-width: 200px;
          transition: 0.2s ease;
        }
        .filter-select:hover, .filter-select:focus {
          border-color: #007bff;
          box-shadow: 0 0 5px rgba(0,123,255,0.3);
        }
        /* LIVE BLINKER ANIMATION */
        .live-indicator {
          display: inline-block;
          width: 8px;
          height: 8px;
          background-color: #00e676; /* Bright Green */
          border-radius: 50%;
          margin-right: 8px;
          box-shadow: 0 0 0 rgba(0, 230, 118, 0.4);
          animation: pulse-green 1.5s infinite;
          vertical-align: middle;
        }

        @keyframes pulse-green {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 230, 118, 0.7);
          }
          70% {
            transform: scale(1);
            box-shadow: 0 0 0 6px rgba(0, 230, 118, 0);
          }
          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 230, 118, 0);
          }
        }
        @media (max-width: 600px) {
          .filter-select {
            width: 100%;
          }
        }
        `}
      </style>

      {/* Modal is kept in case you need it later, though logic wasn't fully used in snippet */}
      {showModal ? (
        <div className="modal-body">
          <div className="modal-content">
            <div className="modal-header">Enter Password</div>
            <div className="modal-c" style={{ backgroundColor: "#fff" }}>
              <div>
                <input
                  autoComplete="off"
                  type="text"
                  placeholder="Password"
                  id="amount"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-btn">
              <button
                className="warn-btn"
                onClick={() => setShowModal(false)}
              >
                Restart
              </button>
              <button onClick={() => setShowModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      ) : null}

      <div className="body-content no-padding">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <div style={{ padding: "10px 10px 0 10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h2 style={{ margin: 0, color: "#444" }}>Revert Results</h2>
        </div>

        {/* --- FILTERS --- */}
        <div className="filter-container">
          <select
            className="filter-select"
            value={filterMatchId}
            onChange={(e) => setFilterMatchId(e.target.value)}
          >
            <option value="">All Matches</option>
            {/* Combine settled matches and sessions for filter options */}
            {unsettledSettledBets.map((match) => (
              <option key={match.event_id} value={match.event_id}>
                {match.event_name}
              </option>
            ))}
          </select>

          <select
            className="filter-select"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="All">All Bet Types</option>
            <option value="Match Bets">Match Bets (Settled)</option>
            <option value="Session Bets">Session Bets (Settled)</option>
          </select>

          <span
            onClick={() => {
              setRefreshing(true);
              window.location.reload();
            }}
            className={isRefreshing ? "rotating" : ""}
            style={{ cursor: "pointer", marginLeft: "auto", color: "#555" }}
            title="Refresh Data"
          >
            <ReplayIcon style={{ fontSize: 30 }} />
          </span>
        </div>

        {/* --- SECTION 1: SETTLED MATCH BETS --- */}
        {shouldShowMatchBets && (
          <>
            <h3
              style={{
                padding: 10,
                color: "#555",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #eee",
                cursor: "pointer",
                userSelect: "none"
              }}
              onClick={() => setShowMatchSection(!showMatchSection)}
            >
              <span>Recently Settled Matches</span>
              <span>
                {showMatchSection ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </span>
            </h3>

            {showMatchSection && (
              <>
                <p
                  style={{
                    paddingLeft: 10,
                    paddingRight: 10,
                    fontSize: 14,
                    color: "#666",
                    marginBottom: 10,
                  }}
                >
                  All bets settled in the last hour.
                </p>

                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                  {filteredSettledMatches.length === 0 ? (
                    <div style={{padding: 15, textAlign: "center", color: "#888"}}>No Settled Matches Found</div>
                  ) : (
                    filteredSettledMatches
                      .sort((a, b) => new Date(b.time) - new Date(a.time))
                      .map((match) => {
                        return (
                          <div key={match.event_id} className="main-btn">
                            <div className="usmb">
                              <span
                                style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                              >
                                {match.event_name}
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={() =>
                                matchLoading === match.event_id
                                  ? console.log("Loading")
                                  : revertMatch(match.event_id)
                              }
                            >
                              {matchLoading === match.event_id ? (
                                <Spinner color="#fff" />
                              ) : (
                                "REVERT"
                              )}
                            </button>
                          </div>
                        );
                      })
                  )}
                </div>
              </>
            )}
          </>
        )}

        {/* --- SECTION 2: SETTLED SESSION BETS --- */}
        {shouldShowSessionBets && (
          <>
            <h3
              style={{
                padding: "20px 10px 10px 10px",
                color: "#555",
                borderBottom: "1px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                userSelect: "none"
              }}
              onClick={() => setShowSessionSection(!showSessionSection)}
            >
              <span>Recently Settled Fancy</span>
              <span>
                {showSessionSection ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </span>
            </h3>
            
            {showSessionSection && sortedMatchList.map((match) => {
              const matchName = match.event_name;
              const data = matchOdds.filter((x) => x.match_id === match.event_id);
              const isVisible = visibleSessions[match.event_id];
              
              // Calculate Live status
              const isLive = checkIsLive(match.time);

              if (data.length === 0) return null;

              return (
                <div
                  className="pr-box"
                  key={match.event_id}
                  style={{ paddingBottom: !isVisible ? 20 : 80 }}
                >
                  <div 
                    className="prbox-header"
                    onClick={() => toggleSession(match.event_id)}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      userSelect: "none"
                    }}
                  >
                    <span>
                      {isLive && <span className="live-indicator" title="Live Today"></span>}
                      {matchName}
                      <br></br>
                      {/* <small><em>{timestampToString(match.time)}</em></small> */}
                    </span>
                    <span style={{ display: "flex", alignItems: "center" }}>
                        {isVisible ? <KeyboardArrowUpIcon style={{ fontSize: 20 }}/> : <KeyboardArrowDownIcon style={{ fontSize: 20 }}/>}
                    </span>
                  </div>

                  {isVisible && (
                  <div className="prbox-body odds-table">
                    <table>
                      <thead>
                        <tr>
                          <th>SESSION</th>
                          <th>Declared</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((odd) => {
                          return (
                            <tr key={odd.fancy_name}>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "100%",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {odd.fancy_name}
                                  </span>
                                </div>
                              </td>
                              <td style={{ fontSize: 12, width: 20 }}>
                                {odd.result}
                              </td>
                              <td>
                                <div
                                  className="table-flex"
                                  style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                  }}
                                >
                                  <button
                                    onClick={() =>
                                      resultLoading === odd.fancy_name
                                        ? () => {}
                                        : resultLoading.length === 0
                                        ? revertBet(odd.fancy_name, odd.match_id)
                                        : () => {}
                                    }
                                    disabled={
                                      (resultLoading.length > 0 &&
                                        resultLoading !== odd.fancy_name) ||
                                      resultLoading !== ""
                                    }
                                    style={{
                                      border: "none",
                                      padding: "8px 12px",
                                    }}
                                  >
                                    {resultLoading === odd.fancy_name ? (
                                      <Spinner
                                        color="#fff"
                                        style={{
                                          height: 13,
                                          width: 13,
                                          borderWidth: 2,
                                        }}
                                      />
                                    ) : (
                                      "REVERT"
                                    )}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    <div></div>
                  </div>
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    </>
  );
}

export default Revert;